import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import {
	KonfiguracjaTopPage,
	type TopConfigTab,
} from "@/features/strateg-cenowy/top/components/config/KonfiguracjaTopPage";
import { ensureElementVisible } from "@/lib/route-guards";

const searchSchema = z.object({
	tab: z.enum(["premium", "seasonal", "auto-seasonal", "weights", "ai"]).optional(),
});

function KonfiguracjaTopRoute() {
	const { tab } = Route.useSearch();
	const navigate = useNavigate({ from: "/strateg-cenowy/konfiguracja-top" });
	const activeTab: TopConfigTab = tab ?? "premium";

	return (
		<KonfiguracjaTopPage
			tab={activeTab}
			onTabChange={(next) => {
				navigate({ search: { tab: next }, replace: true });
			}}
		/>
	);
}

export const Route = createFileRoute("/_auth/strateg-cenowy/konfiguracja-top")({
	validateSearch: searchSchema,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.strateg-cenowy.konfiguracja-top",
			location.pathname,
		);
	},
	component: KonfiguracjaTopRoute,
});
